<template>
  <div>
    <div class="cooperation_wrap">
      <div class="cooperation_tit">
        <div>中心简介</div>
        <div class="en-font">Center Overview</div>
      </div>
      <div class="cooperation_desc">
        <div>持续为用户创造独特价值</div>
        <div class="en-font">Continuously creating unique value for users</div>
      </div>
      <div class="cooperation_box">
        <div class="right"></div>
        <div class="left">
          <p class="content">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氢能装备制造业创新中心以“公司+联盟”形式联合打造，由政府、企业、高校、科研机构等主体联动共建，聚焦氢能装备领域，以氢能制取、氢能储运、氢能应用相关技术为主攻方向，打通“行业技术攻关——中试——转移转化——工艺优化——首次商业化”创新链条各环节，提供氢能产业创新的公共服务，积极开展国际交流与人才培养合作，打造跨界协同的创新生态系统...
          </p>
          <el-button class="btn" type="primary" @click="handleMore"
            >了解更多<br />learn more</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleMore() {
      this.$router.push("/fivenav/1");
    },
  },
};
</script>

<style lang="scss" scoped>
.cooperation_wrap {
  width: 100%;
  text-align: center;
  background: url("~@/assets/img/bottom_bg.90c1ea1.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  padding-bottom: 60px;
  .cooperation_tit {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
    padding-top: 50px;
    .en-font {
      font-size: 20px;
    }
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
      .en-font {
        font-size: 0.6rem;
      }
    }
  }
  .cooperation_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 24px;
    margin-top: 30px;
    .en-font {
      font-size: 20px;
    }
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      .en-font {
        font-size: 0.6rem;
      }
    }
  }
  .cooperation_box {
    width: 70%;
    margin: 0 auto;
    padding-top: 50px;
    position: relative;
    .left {
      .content {
        font-size: 20px;
        text-align: left;
        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }
      .btn {
        @media screen and (max-width: 768px) {
          font-size: 10px;
        }
      }
    }
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .cooperation_item {
      img {
        width: 100%;
      }
    }
    .change_page {
      position: absolute;
      bottom: 40px;
      right: 40px;
      @media screen and (max-width: 768px) {
        bottom: 5px;
        right: 5px;
      }
    }
  }
}
.cooperation_bottom {
  width: 100%;
  height: 300px;
  background: url("~@/assets/img/bannershow.png") 0 0 no-repeat;
  background-size: contain;
  .details_show {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .show_item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .show_top {
        color: #717171;
        font-size: 50px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 16px;
        }
      }

      .show_bottom {
        color: #717171;
        font-size: 25px;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
  }
}
</style>